import React, {useState} from 'react';
import {Chip, Grid, IconButton, Menu, MenuItem} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {useNavigate} from 'react-router-dom';
import {
  deletePOCTool,
  publishPOCTools,
  unPublishPOCTools,
} from '../../../api/POCCMSPortalAPI/pointOfCareTools/POCToolsCalls';
import {formatDate} from '../../../Util/converter';

type Props = {
  name: string;
  id: string;
  isPublished: boolean;
  publishDate: Date | string;
  lastUpdated: Date | string;
  updatedBy: string;
  isSuperPOCTool: boolean;
};

export default function POCToolSummaryTableItem(props: Props) {
  const {
    name,
    id,
    isPublished,
    publishDate,
    lastUpdated,
    updatedBy,
    isSuperPOCTool,
  } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleEdit = () => {
    navigate(`/EditPOCTool/:${id}`);
  };
  const deleteHandler = () => {
    deletePOCTool(id).then(() => window.location.reload());
  };
  const publishHandler = () => {
    const publishAction = isPublished
      ? unPublishPOCTools(id)
      : publishPOCTools(id);
    publishAction
      .then(() => window.location.reload())
      .catch(err => {
        if (err === 401) {
          navigate('/Login');
        } else {
          alert('Error');
        }
      });
  };

  return (
    <Grid container>
      <Grid item xs={3} sm={3} md={3} lg={3}>
        <div style={styles.nameContainer}>
          <span>{name}</span>
        </div>
      </Grid>
      <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5}>
        <Chip
          label={isPublished ? 'Published' : 'Draft'}
          color={isPublished ? 'success' : 'primary'}
        />
      </Grid>
      <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5}>
        <div style={styles.columnText}>
          <span>{formatDate(publishDate)}</span>
        </div>
      </Grid>
      <Grid item xs={2} sm={2} md={2} lg={2}>
        <div style={styles.columnText}>
          <span>{updatedBy}</span>
        </div>
      </Grid>
      <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5}>
        <div style={styles.columnText}>
          <span>{formatDate(lastUpdated)}</span>
        </div>
      </Grid>
      <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5}>
        <div style={styles.columnText}>
          <span>{isSuperPOCTool ? 'Yes' : 'No'}</span>
        </div>
      </Grid>
      <Grid item xs={1} sm={1} md={1} lg={1}>
        <IconButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          disableRipple={true}
          disableFocusRipple={true}
          focusRipple={false}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}>
          <MenuItem onClick={handleEdit}>Edit</MenuItem>
          <MenuItem onClick={publishHandler}>
            {isPublished ? 'Unpublish' : 'Publish'}
          </MenuItem>
          <MenuItem onClick={deleteHandler}>Delete</MenuItem>
        </Menu>
      </Grid>
    </Grid>
  );
}

const styles = {
  columnText: {height: 30, alignItems: 'center', display: 'flex'},
  buttonContainer: {height: 30, width: 30, padding: 0},
  showListButton: {width: '100%'},
  actionList: {
    padding: 0,
    zIndex: 99,
    position: 'absolute',
    flexDirection: 'column',
  },
  buttonContainerStyle: {
    marginBottom: 1,
    color: 'black',
    fontWeight: '600',
  },
  buttonStyle: {
    width: '100%',
  },
  nameContainer: {height: 30, alignItems: 'center', display: 'flex'},
};
